import { render, staticRenderFns } from "./ChannelAccount.vue?vue&type=template&id=f4d9f432&scoped=true&"
import script from "./ChannelAccount.vue?vue&type=script&lang=js&"
export * from "./ChannelAccount.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAccount.vue?vue&type=style&index=0&id=f4d9f432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9f432",
  null
  
)

export default component.exports